import logger from 'js/app/loggerSingleton';

import type { ProductType } from '@coursera/event-pulse-types';

import type SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';

const getEventingV3ProductType = (subscription: SubscriptionsV1) => {
  if (subscription.isSpecializationSubscription) {
    return 's12n';
  } else if (subscription.isCourseraLiteSubscription) {
    return 'clite';
  } else if (subscription.isCourseraPlusSubscription) {
    return 'cplus';
  }

  return undefined;
};

export const getEventingV3Product = (subscription: SubscriptionsV1) => {
  const productType = getEventingV3ProductType(subscription);

  if (!productType) {
    logger.error(`Cannot get EventingV3 product type for subscription ${subscription.id}`);
    return undefined;
  }

  return {
    id: subscription.productItemId,
    type: productType as ProductType,
  };
};
